module.exports = __webpack_public_path__ + "static/media/favourite-stroke.2f4230ec.svg";